"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _MuiHeroHeader = _interopRequireDefault(require("../../../MuiHeroHeader/MuiHeroHeader"));

var MuiMobileTab = function MuiMobileTab(_ref) {
  var tab = _ref.tab;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      overflow: 'hidden'
    }
  }, /*#__PURE__*/_react.default.createElement(_MuiHeroHeader.default, tab));
};

var _default = MuiMobileTab;
exports.default = _default;
MuiMobileTab.propTypes = {
  /** State you would like to show if user is in this state */
  geocodeState: _propTypes.default.string,

  /** props to spread to  */
  tab: _propTypes.default.shape.isRequired
};
MuiMobileTab.defaultProps = {
  geocodeState: ''
};